import { RefreshCw } from 'lucide-react';
import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import type { NfseDocumento } from '@/services/ServicosNfse';
import { NfseTable } from './NfseTable';
import type { SortDirectionNfse, SortFieldNfse } from './hooks/useServicosNfsePage';

interface NfseListCardProps {
  title: string;
  description: string;
  documentos: NfseDocumento[];
  totalItens: number;
  isLoading: boolean;
  isFetching: boolean;
  atualizando: boolean;
  tipo: 'tomados' | 'prestados';
  paginaAtual: number;
  itensPorPagina: number;
  sortField: SortFieldNfse;
  sortDirection: SortDirectionNfse;
  onAtualizar: () => void;
  onPaginaChange: (pagina: number) => void;
  onItensPorPaginaChange: (itensPorPagina: number) => void;
  onSelectDocumento: (documento: NfseDocumento) => void;
  onSortChange: (field: SortFieldNfse) => void;
  actions?: ReactNode;
  showAtualizar?: boolean;
}

export function NfseListCard({
  title,
  description,
  documentos,
  totalItens,
  isLoading,
  isFetching,
  atualizando,
  tipo,
  paginaAtual,
  itensPorPagina,
  sortField,
  sortDirection,
  onAtualizar,
  onPaginaChange,
  onItensPorPaginaChange,
  onSelectDocumento,
  onSortChange,
  actions,
  showAtualizar = true,
}: NfseListCardProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          <div className="flex flex-wrap items-center justify-end gap-2">
            {actions}
            {showAtualizar && (
              <Button variant="outline" size="sm" onClick={onAtualizar} disabled={atualizando}>
                <RefreshCw className={`mr-2 h-4 w-4 ${atualizando ? 'animate-spin' : ''}`} />
                Atualizar
              </Button>
            )}
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <NfseTable
          documentos={documentos}
          totalItens={totalItens}
          isLoading={isLoading}
          isFetching={isFetching}
          tipo={tipo}
          paginaAtual={paginaAtual}
          itensPorPagina={itensPorPagina}
          sortField={sortField}
          sortDirection={sortDirection}
          onPaginaChange={onPaginaChange}
          onItensPorPaginaChange={onItensPorPaginaChange}
          onSelectDocumento={onSelectDocumento}
          onSortChange={onSortChange}
        />
      </CardContent>
    </Card>
  );
}
